export enum RoleOptions {
  ALL = "All",
  ROLE_ADMIN = "Admin",
  ROLE_CONTRACTOR = "Contractor",
  ROLE_HR = "Hr",
  ROLE_MANAGER = "Manager",
  ROLE_USER = "User",
}

export enum SitesRoleOptions {
  ALL = "All",
  ROLE_ADMIN = "Admin",
  ROLE_CONTRACTOR = "Contractor",
  ROLE_HR = "Hr",
  ROLE_MANAGER = "Manager",
  ROLE_USER = "All Users",
}

export enum RoleOptionsNoAll {
  ROLE_ADMIN = "Admin",
  ROLE_CONTRACTOR = "Contractor",
  ROLE_HR = "Hr",
  ROLE_MANAGER = "Manager",
  ROLE_USER = "User",
}

export enum RoleOptionsUserAll {
  ROLE_USER = "All Users",
  ROLE_ADMIN = "Admin",
  ROLE_CONTRACTOR = "Contractor",
  ROLE_HR = "Hr",
  ROLE_MANAGER = "Manager",
}
